import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f94262ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-toolbar-header" }
const _hoisted_2 = { class: "page-toolbar-header__title-block" }
const _hoisted_3 = { class: "page-toolbar-header__titles" }
const _hoisted_4 = {
  key: 0,
  class: "page-toolbar-header__title"
}
const _hoisted_5 = {
  key: 1,
  class: "page-toolbar-header__subtitle"
}
const _hoisted_6 = {
  key: 0,
  class: "page-toolbar-header__actions"
}
const _hoisted_7 = { class: "page-toolbar-header__search-icon" }
const _hoisted_8 = {
  class: "page-toolbar-header__add-icon",
  "aria-hidden": "true"
}
const _hoisted_9 = {
  class: "page-toolbar-header__add-icon",
  "aria-hidden": "true"
}

import { computed } from "vue";
import { useRouter } from "vue-router";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faArrowLeft,
  faMagnifyingGlass,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { usePageToolbar } from "@/core/hooks/usePageToolbar";
import Can from "@/components/Can.vue";
import PageToolbarFilterDropdown from "@/layout/header/PageToolbarFilterDropdown.vue";
import PageToolbarApprovalDropdown from "@/layout/header/PageToolbarApprovalDropdown.vue";
import PageToolbarActionsDropdown from "@/layout/header/PageToolbarActionsDropdown.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PageToolbarHeader',
  props: {
  hideBack: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const router = useRouter();
const {
  pageToolbar,
  searchQuery,
  displayTitle,
  displaySubtitle,
  showBack: toolbarShowBack,
} = usePageToolbar();

const showBack = computed(() => !props.hideBack && toolbarShowBack.value);

const hasActions = computed(
  () =>
    pageToolbar.showSearch ||
    pageToolbar.showFilter ||
    pageToolbar.showApproval ||
    pageToolbar.showActions ||
    Boolean(pageToolbar.addLabel)
);

function handleBack() {
  if (pageToolbar.onBack) {
    pageToolbar.onBack();
    return;
  }
  if (window.history.length > 1) {
    router.go(-1);
  } else {
    router.push({ name: "dashboard" });
  }
}

function handleAdd() {
  pageToolbar.onAdd?.();
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (showBack.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "page-toolbar-header__back",
            title: "Quay lại",
            onClick: handleBack
          }, [
            _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faArrowLeft) }, null, 8, ["icon"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (_unref(displayTitle))
          ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString(_unref(displayTitle)), 1))
          : _createCommentVNode("", true),
        (_unref(displaySubtitle))
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(displaySubtitle)), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (hasActions.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_unref(pageToolbar).showSearch)
            ? (_openBlock(), _createBlock(_component_el_input, {
                key: 0,
                modelValue: _unref(searchQuery),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : null)),
                class: "page-toolbar-header__search",
                clearable: "",
                placeholder: _unref(pageToolbar).searchPlaceholder
              }, {
                prefix: _withCtx(() => [
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faMagnifyingGlass) }, null, 8, ["icon"])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"]))
            : _createCommentVNode("", true),
          _createVNode(PageToolbarFilterDropdown),
          _createVNode(PageToolbarApprovalDropdown),
          _createVNode(PageToolbarActionsDropdown),
          (_unref(pageToolbar).addLabel && _unref(pageToolbar).addPermissions.length)
            ? (_openBlock(), _createBlock(Can, {
                key: 1,
                all: _unref(pageToolbar).addPermissions
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    type: "button",
                    class: "page-toolbar-header__add",
                    onClick: handleAdd
                  }, [
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faPlus) }, null, 8, ["icon"])
                    ]),
                    _createElementVNode("span", null, _toDisplayString(_unref(pageToolbar).addLabel), 1)
                  ])
                ]),
                _: 1
              }, 8, ["all"]))
            : (_unref(pageToolbar).addLabel)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "button",
                  class: "page-toolbar-header__add",
                  onClick: handleAdd
                }, [
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faPlus) }, null, 8, ["icon"])
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_unref(pageToolbar).addLabel), 1)
                ]))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})